import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CancerCards from "../../../../../components/Cards/CancerCards";
import Dia_Header from "./Dia_Header";
import Dia_Breast_Genes from "./Dia_Breast_Genes";
import Dia_Breast_Variants from "./Dia_Breast_Variants";
//import Dia_Learn from "./Dia_Learn.";
import BreastSingleVariantStack from "./BreastSingleVariantStack";


export default function Breast() {

return (
<>
<CancerCards  

content = {<>
                <Grid container >  

                        <Grid item xs={12} >
                                <Dia_Header />
                        </Grid>   
        
                        <Grid item xs={10} >
                        <Dia_Breast_Genes />
                        </Grid>

                        <Grid item xs={2}>
                        
                        </Grid>
                </Grid>

                <Grid container sx={{ mt:1}}>  

                        <Grid item xs={9} >
                                <Typography variant="h4" sx={{color: 'common.white', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '60%', xl: '100%' }, }}> 
                                        YOUR VARIANTS </Typography>
                                <Typography variant="h6" sx={{mb:2, color: 'common.white', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '60%', xl: '80%' }, }}> 
                                        (likely) pathogenic</Typography>
                        </Grid>

                        <Grid item xs={2} >
                                <Dia_Breast_Variants />
                        </Grid>

                        <Grid item xs={12} >
                                <BreastSingleVariantStack />
                        </Grid>
                        </Grid>

                </>}

               

                />
</>
)};
